<template>
  <vs-row class="h-screen flex w-full" vs-type="flex" vs-justify="center">
    <!-- <div class="h-screen flex w-full" v-else> -->
    <div
      class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto"
      v-if="orderFound"
    >
      <h3
        class="sm:mx-0 mx-4 mb-6 text-4xl d-theme-heading-color text-center"
      >Tracking order number {{order}}</h3>
      <vx-card>
        <!-- <ul class="vx-timeline">
          <li v-for="item in timelineData" :key="item.title">
            <div class="timeline-icon" :class="`bg-${item.color}`">
              <feather-icon :icon="item.icon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="timeline-info">
              <p class="font-semibold">{{ item.title }}</p>
              <span class="activity-desc">{{ item.desc }}</span>
            </div>
            <small class="text-grey activity-e-time">{{ item.time }}</small>
          </li>
        </ul> -->
        <ul class="vx-timeline">
          <li v-for="item in trackingData" :key="item.label">
            <div class="timeline-icon" :class="`${item.value}`=='null' ? 'bg-grey': 'bg-success'">
              <feather-icon icon="CheckIcon" svgClasses="text-white stroke-current w-5 h-5" />
            </div>
            <div class="timeline-info">
              <p class="font-semibold">{{ item.text }}</p>
              <!-- <span class="activity-desc">{{ item.desc }}</span> -->
            </div>
            <small class="text-grey activity-e-time">{{ item.value == null ? '....' : item.value }}</small>
          </li>
        </ul>
      </vx-card>
    </div>
    <div class="h-screen flex w-full" v-else>
      <div
        class="vx-col flex items-center justify-center flex-col sm:w-1/2 md:w-3/5 lg:w-3/4 xl:w-1/2 mx-auto text-center"
      >
        <h1 class="sm:mx-0 mx-4 mb-6 text-5xl d-theme-heading-color">{{finding_status}}</h1>
        <!-- <p class="sm:mx-0 mx-4 mb-6 d-theme-text-inverse">paraphonic unassessable foramination Caulopteris worral Spirophyton encrimson esparcet aggerate chondrule restate whistler shallopy biosystematy area bertram plotting unstarting quarterstaff.</p> -->
        <!-- <vs-button size="large" to="/">Back to Home</vs-button> -->
      </div>
    </div>

    <!-- <p class="m-0" v-else>{{finding_status}}</p> -->
  </vs-row>
</template>
<script>
import { _timeline } from "@/services/Order";
import { WEB_SERVER_HOST } from "@/environment/index";
import Echo from "laravel-echo";
window.io = require("socket.io-client");

window.Echo = new Echo({
  broadcaster: "socket.io",
  host: WEB_SERVER_HOST,
});
export default {
  mounted() {
    _timeline(this.order).then(
      (response) => {
         window.Echo.channel(`${this.order}`).listen('.channel-order-status', e => {
          this.trackingData = e.data
      });
        this.orderFound = true;
        this.trackingData = response.data.data
      },
      (err) => {
        this.finding_status = err.response.data.message;
        this.$vs.notify({
          title: "Order Response",
          text: err.response.data.message,
          iconPack: "feather",
          icon: "icon-alert-circle",
          color: "warning",
        });
      }
    );
  },
  destroyed() {

  },
  data() {
    return {
      trackingData: '',
      order: this.$route.params.order,
      orderFound: false,
      finding_status: "Finding Order.......",
    };
  },
};
</script>


<style lang="scss">
@import "@/assets/scss/vuexy/components/vxTimeline.scss";
</style>

